import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ToggleButtonGroup,
  Typography,
  // Switch,
  // FormControlLabel,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from "../../common/icon-button";
import Button from "../../common/button";
import OutlinedInput from "../../common/outlined-input";
import ToggleButton from "../../common/toggle-button";
import isNotEmptyNumber from "../../../helpers/is-not-empty-number.ts";

type SlippageSettingsDialogProps = {
  open: boolean;
  onClose: (isVisible: boolean) => void;
  slippage: number | null;
  onSlippageChange?: (value: string) => void;
  setSlippageValueRaw: (value: string) => void;
}

const presetValues: number[] = [1, 5, 10];

const SlippageSettingsDialog: React.FunctionComponent<SlippageSettingsDialogProps> = ({
                                                                                        open,
                                                                                        onClose,
                                                                                        slippage,
                                                                                        onSlippageChange,
                                                                                        setSlippageValueRaw
                                                                                      }) => {
  const [customValue, setCustomValue] = React.useState(slippage ? slippage.toString() : '');
  // const [expertMode, setExpertMode] = React.useState(false);

  const onPresetChange = (_: any, value: number | null) => {
    if (value !== null) {
      setCustomValue(value.toString());
      if (isNotEmptyNumber(value) && setSlippageValueRaw) {
        setSlippageValueRaw(value.toString());
        onClose(false);
      }
    }
  };

  const onSlippageValueChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const value = evt.target.value;
    setCustomValue(value);
    if (onSlippageChange) {
      onSlippageChange(value);
    }
  };

  // const handleExpertToggle = (_: any, checked: boolean) => {
  //   setExpertMode(checked);
  // };

  const onDialogVisibleChange = () => {
    onClose(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{display: 'flex', justifyContent: 'space-between', alignitems: 'center'}}>
        Settings
        <IconButton onClick={onDialogVisibleChange} size="small">
          <CloseIcon/>
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {/*<FormControlLabel*/}
        {/*  control={<Switch checked={expertMode} onChange={handleExpertToggle}/>}*/}
        {/*  label={*/}
        {/*    <Typography display="flex" alignitems="center">*/}
        {/*      <SchoolIcon fontSize="small" sx={{mr: 0.5}}/> Expert mode*/}
        {/*    </Typography>*/}
        {/*  }*/}
        {/*/>*/}

        <Typography mt={3} fontWeight={500}>
          Slippage Tolerance
        </Typography>
        <Typography variant="body2" color="var(--main-font-color)" mb={1}>
          Your transaction will revert if the price changes unfavorably by more than this percentage.
        </Typography>

        <OutlinedInput
          isfullwidth={true}
          variant="outlined"
          value={customValue}
          onChange={onSlippageValueChange}
          inputProps={{inputMode: 'decimal'}}
        />

        <ToggleButtonGroup
          exclusive
          fullWidth
          value={parseFloat(customValue)}
          onChange={onPresetChange}
          sx={{mt: 2}}
        >
          {presetValues.map((val) => (
            <ToggleButton key={val} value={val}>{val}%</ToggleButton>
          ))}
        </ToggleButtonGroup>
      </DialogContent>

      <DialogActions>
        <Button type="button" onClick={onDialogVisibleChange}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SlippageSettingsDialog;
